import classNames from "classnames";
import { ChildTab } from "../ChildTab";
import { ChildTabsRendererProps } from "../../Types";
import { useMemo } from "react";

const TAB_GAP = 2;
const TAB_HEIGHT = 31;
const MARGIN_Y = 14;

export function ChildTabsRenderer(props: ChildTabsRendererProps) {
  const { isParentTabExpanded, subNavList, ...rest } = props;
  const visibleSubNavList = subNavList.filter((subNavListItem) => subNavListItem.visible ?? true);
  const tabCount = visibleSubNavList.length;
  const height = useMemo(() => (tabCount - 1) * (TAB_HEIGHT + TAB_GAP) + TAB_HEIGHT + MARGIN_Y, [tabCount]);

  return (
    <div
      className="tw-overflow-hidden tw-transition-all tw-duration-150  tw-ease-in"
      style={{
        height: isParentTabExpanded ? height : 0,
      }}
    >
      <div
        className={classNames(
          "tw-ml-[30px] tw-mt-[2px] tw-flex tw-flex-col tw-gap-[2px] tw-border-l tw-border-solid tw-border-[#111C3633] tw-text-[13px]/[15px]",
        )}
      >
        {visibleSubNavList.map((subNavListItem) => 
          <ChildTab key={subNavListItem?.id} subNavListItem={subNavListItem} isDropdown={true} {...rest} />,
        )}
      </div>
    </div>
  );
}
